import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'mobx-react';
import store from './store';
import { setOption, initKey, setParamsHeaders, getUrlParam, getCookie } from './utils';
import './common.less';
import './com/mescroll.min.css';

let gameApp = getUrlParam('gameApp');
let OSType: string = getUrlParam('OSType');
let share: string = getUrlParam('share');
let entry: string = OSType == '2' || OSType == '4' ? 'App' : gameApp ? 'game' : 'H5';

if (gameApp && !share) {
    entry = 'game';
}

if (gameApp && share) {
    entry = 'H5';
    store.status.isShowHead = false;
}

// 判断入口是游戏还是微信
if (entry === 'game') {
    store.status.gameApp = true;
    store.status.gameId = getUrlParam('appId');  // 游戏id
    // 测试环境
    // 设置默认请求
    let url: string;
    if (window.location.href.indexOf('https://wechat.gjyymall.com') !== -1) {
        url = 'https://wechat.gjyymall.com/api/pub/'; // 测试环境
    } else if (window.location.href.indexOf('https://wechat.gjyymall.com') !== -1) {
        url = 'https://wechat.gjyymall.com/api/pub/'; // 正式环境
    } else {
        url = 'https://wechat.gjyymall.com/api/pub/'; // 正式环境
    }
    if (!getUrlParam('gameApp')) {
        let urlArr: any[] = location.href.split('#');
        window.history.replaceState(null, document.title, `${urlArr[0]}?f=1&gameApp=true#${urlArr[1] ? urlArr[1] : '!/'}`);
    }
    setOption({
        url: url,
        defaultMethod: 'POST',
    });
    setParamsHeaders({
        accountType: 3,
        osType: 3,
        'pub-token': getCookie('pub-token')
    });
    // 请求登陆
    initKey().then(() => {

    }).then(() => {

    });
} else if (entry === 'H5') {
    // 设置默认请求
    let url: string = '';
    let appId: string = '';
    if (window.location.href.indexOf('https://wechat.gjyymall.com') !== -1) {
        url = 'https://wechat.gjyymall.com/api/pub/'; // 测试环境
            // appId = 'wx742b2c8612574a8b';
        appId = 'wx2221b616ef2ea5f1';
    } else {
        url = 'https://wechat.gjyymall.com/api/pub/'; // 正式环境
            // appId = 'wx742b2c8612574a8b';
        appId = 'wx2221b616ef2ea5f1';
    }
    setOption({
        url: url,
        appUrl: url + 'user/weixin/v1/login',
        appId: appId,
        defaultMethod: 'POST',
    });
    store.user.setPartnerId();

    if (window.location.href.indexOf('?') === -1) {
        // window.location.replace(window.location.href.replace('#!', '?f=1/#!'));
        let urlArr: any[] = location.href.split('#');
        window.history.replaceState(null, document.title, `${urlArr[0]}?f=1#${urlArr[1] ? urlArr[1] : '!/'}`);
    }
    if (window.location.href.indexOf('/appdetail') <= -1) {
        initKey().then((e: any) => {
            if (e) {
                store.user.fetch().then(() => {
                    store.user.shopNum();
                    store.user.getShopName();
                    return store.user.add();
                });
            }
        });
    }
} else if (entry === 'App') {
    store.status.isApp = true;
    let url: string = '';
    if (window.location.href.indexOf('http://wechat.gjyymall.com') !== -1) {
        url = 'http://wechat.gjyymall.com/api/pub/'; // 测试环境
    } else if (window.location.href.indexOf('http://wechat.gjyymall.com') !== -1) {
        url = 'http://http://wechat.gjyymall.com/api/pub/'; // 正式环境
    } else {
        url = 'http://wechat.gjyymall.com/api/pub/'; // 正式环境

    }
    setOption({
        url: url,
        defaultMethod: 'POST',
    });
    setParamsHeaders({
        accountType: getUrlParam('accountType'),
        osType: OSType,
        'pub-token': getUrlParam('token')
    });

    store.user.setPartnerId();

    store.user.shopNum();
}

ReactDOM.render(
    <Provider {...store}>
        <App />
    </Provider>,
    document.getElementById('root') as HTMLElement
);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/indexbuild.tsx